<template>
	<div class="list">
		<div class="list-tt">基本信息</div>
		<div class="list-info" v-html="infoHtml"></div>
	</div>
</template>

<script>
	export default {
		props: ['baseInfo'],
		data() {
			return {
				infoHtml: '',
				sex:{1:'男',2:'女'},
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				
			}
		},
		methods: {
			getBazi() {
				let type = this.baseInfo.type;
				let sex = this.baseInfo.sex;
				let year = this.baseInfo.year;
				let month = this.baseInfo.month;
				let day = this.baseInfo.day;
				let chen = [23,2,4,6,8,10,12,14,16,18,20,22];
				let time = chen[this.baseInfo.time];
				let timeName = this.times[this.baseInfo.time];
				
				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					this.infoHtml =
						`
						<dl><dt>农历生日</dt><dd>${lunar} ${timeName}</dd></dl>
						<dl><dt>生肖</dt><dd>${lunar.getYearShengXiaoByLiChun()}</dd></dl>
						<dl><dt>对应公历</dt><dd>${lunar.getSolar()} / ${lunar.getSolar().getXingZuo()}座</dd></dl>
						<dl><dt>性别</dt><dd>${this.sex[sex]}</dd></dl>
					`;
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					this.infoHtml =
						`
						<dl><dt>公历生日</dt><dd>${lunar.getSolar()}</dd></dl>
						<dl><dt>生肖</dt><dd>${lunar.getYearShengXiaoByLiChun()}</dd></dl>
						<dl><dt>对应农历</dt><dd>${lunar} ${timeName}</dd></dl>
						<dl><dt>性别</dt><dd>${this.sex[sex]}</dd></dl>
					`;
				}
			},
		},
		watch: {
			baseInfo(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/base.vue